<template>
    <div id="mobile-user-container">
      <div class="mobile-user-icon" @click="toggleMobileMenu">
        <i class="bi bi-person-fill user-icon"></i>
      </div>
      
      <div class="mobile-menu" :class="{ 'mobile-menu-open': isMobileMenuOpen }">
        <div class="mobile-menu-item email" v-if="user.isAuthenticated">
          <span v-if="user?.user?.profile?.email">{{ user.user.profile.email }}</span>
          <span v-else>No email</span>
        </div>
        <div class="mobile-menu-item" @click="loginButton">
          {{ user.isAuthenticated ? 'Logout' : 'Login' }}
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { computed, defineComponent, inject, ref, watch } from 'vue'
  import { authenticationInformation } from '@/oidc/authentication'
  import { useOrganizationsStore } from '@/stores'
  import { storeToRefs } from 'pinia'
  
  export default defineComponent({
    name: 'MobileTopbarUserComponent',
    setup() {
      const user = authenticationInformation().user
      const orgStore = useOrganizationsStore()
      const { organizations } = storeToRefs(orgStore)
      const isMobileMenuOpen = ref(false)
  
      const loginButton = () => {
        if (!user?.isAuthenticated) {
          user?.login()
        } else {
          user?.logout()
        }
        closeMobileMenu()
      }
  
      const isAdminOfOrg = ref<boolean>(false)
  
      watch(organizations, async (newOrg) => {
        const orgs = await newOrg
        isAdminOfOrg.value = orgs !== null && orgs?.length > 0
      })
  
      const toggleMobileMenu = () => {
        isMobileMenuOpen.value = !isMobileMenuOpen.value
      }
  
      const closeMobileMenu = () => {
        isMobileMenuOpen.value = false
      }
  
      return {
        user,
        isAdminOfOrg,
        isMobileMenuOpen,
        toggleMobileMenu,
        closeMobileMenu,
        loginButton,
      }
    },
  })
  </script>
  
  <style lang="scss" scoped>
  #mobile-user-container {
    position: relative;
  }
  
  .mobile-user-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3.75rem;
    min-height: 3.75rem;
    width: 3.75rem;
    min-width: 3.75rem;

    cursor: pointer;
  
    .user-icon {
      font-size: 1.5rem;
    }
  }
  
  .mobile-menu {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    background-color: $light-gray;
    box-shadow: 0 5px 8px 0 rgb(0 0 0 / 20%);
    min-width: 200px;
    z-index: 1000;
  
    &.mobile-menu-open {
      display: block;
    }
  
    .mobile-menu-item {
      padding: 1rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
  
      &.email {
        font-size: 0.9rem;
        opacity: 0.8;
      }
  
      a {
        color: $petrol;
        text-decoration: none;
        display: block;
      }
  
      &:last-child {
        border-bottom: none;
      }
    }
  }
  </style>